module.exports = __webpack_public_path__ + "img/csgia.3892ccd5.png";